import { Box, Card, CardContent, Container, Grid, Typography } from '@mui/material';
import img0 from '../../utils/images/aboutUs.jfif';
import img1 from '../../utils/images/aboutUs1.JPG';
import img2 from '../../utils/images/aboutUs2.jfif';
import React from 'react';
import { Navbar } from '../../components/Navbar/Navbar';
import Button from '@mui/material/Button';
import Ticker from 'react-ticker';

import Tickers from '../../components/Tickers/Tickers';
import Footer from '../../components/Footer/Footer';

const InnerBlog = () => {
  return (
    <div>
      <Navbar />
      {/* <Ticker style={{ backgroundColor: '#333333', }} >
        {({ index }) => (
          <>
            <div style={{ backgroundColor: "#FF7345", marginTop: "70px", color: "white", width: '200px' }}>
              <Typography sx={{ fontFamily: "Sora", marginRight: 2, lineHeight: 2.5, marginRight: '28px', }}>
                Sample News <></>
              </Typography>
            </div>
          </>
        )}
      </Ticker> */}
      <Grid
        sx={{
          display: 'flex',
          flexDirection: 'column',
          width: '100vw',
          fontFamily: 'Sora',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Typography
          variant="h5"
          sx={{
            display: 'flex',
            width: '40vw',
            fontFamily: 'Sora',
            justifyContent: 'center',
            alignItems: 'center',
            color: '#223230',
            fontWeight: '600',
            marginTop: 15,
            fontSize: '2rem',
          }}
        >
          Social interactions and relationships in college
        </Typography>

        <Box sx={{ flexGrow: 1, px: [0, 0, 0, 0], marginTop: 2 }}>
          <Grid>
            <Grid sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
              <Typography
                sx={{
                  color: 'var(--unnamed-color-223230)',
                  fontFamily: 'Sora',
                  fontSize: '13px',
                  width: '90%',
                  marginTop: '10px',
                  opacity: 0.67,
                }}
              >
                Department: School of Public Health
              </Typography>
              {/* <Typography
                                sx={{
                                    color: 'var(--unnamed-color-223230)',
                                    fontFamily: 'Sora',
                                    fontSize: '13px',
                                    width: '90%',
                                    marginTop: '10px',
                                    opacity: 0.67,
                                    textAlign: 'right',
                                }}
                            >

                                Published on 12/04/2022
                            </Typography> */}
            </Grid>
            <Box sx={{ display: 'flex', px: [0, 0, 0], alignItems: 'center', justifyContent: 'center' }}>
              <CardContent sx={{ width: '40vw', px: 0 }}>
                <img
                  style={{
                    width: '40vw',
                    height: '40vh',
                  }}
                  src={img2}
                />
                <br />

                <Typography
                  sx={{
                    marginTop: 4,
                    color: 'var(--unnamed-color-151515)',
                    font: '30px ',
                    width: '100%',
                    textAlign: 'justify',
                    
                  }}
                >
                  Social interactions and relationships in college Students come to college with a lot of expectations,
                  hopes, and goals and often with some fears. Students have to face a series of challenges while in
                  college. Whether it is academics, attendance, exams, parental pressures, lack of sleep, social
                  pressures, language barrier, student-faculty interactions, or food, students are constantly under
                  various pressures and changes throughout their time in college. It can often be up to the department
                  to create a nurturing space for growth, accountability, learning, critical thinking and problem
                  solving. A major aspect of a student’s experience in college are their social interactions and social
                  relationships. This is something they are faced with on a daily basis.
                  <br></br>
                  <br></br>
                  The social interactions you have in college determine your experience and the extent to which you are
                  able to grow and become the kind of person you want to be on a professional and personal level. The
                  social networks you form in college can stick with you throughout your life. It affects several
                  aspects of a students’ life, some of which include their academic development, studying ability,
                  placements and personal relationships.
                  <br></br>
                  <br></br>
                  As a department, the School of Public Health (SPH) aims to create an environment necessary for them to
                  explore their potential, grow academically and personally. We believe we provide student with a
                  nurturing environment in terms mentorship, guidance and opportunities for growth. Our mentorship
                  program aims to tackle, the often lack of, faculty and student interaction and engagement. Students
                  are connected to a faculty member from the time they join the department to when they graduate.
                  Throughout this time, they are able to seek help from their mentors for personal, academic and
                  professional matters. This has helped students not only learn how to develop professional
                  relationships, but to get the guidance they may need when necessary, without hesitation. This program
                  has been effective in giving students a designated person they are able to go to when faced with a
                  challenge.
                  <br></br>
                  <br></br>
                  Social relationships and interactions during one’s college experience make up a very important aspect
                  of a student’s life. This can often be challenging for many students and is important to address as
                  they experience it, through mentorship program and giving students a space to be open and honest.
                  <br></br>
                  <br></br>
                  What can SPH offer you?
                  <br></br>
                  <br></br>
                  SRM, School of Public Health (SPH) aims to create public health leaders through interdisciplinary
                  education and research. As part of SPH, the University Wellness Program (UWP) looks at the wellness of
                  all the students on campus. Our aim is to look at various factors that affect students’ wellbeing and
                  find ways to address them. Wellness plays a significant role in the lives of students on a daily
                  basis.
                  <br></br>
                  <br></br>
                  SRM, as a whole, has made it a priority to help students address the various challenges that may come
                  with wellness, especially in terms your mental health. It is becoming more and more important to
                  address these issues, especially in today’s climate of uncertainty and adjusting to the new norm of
                  life, education, socialization, interactions and everything that comes with that.
                  <br></br>
                  <br></br>
                  SPH is dedicated to not only provide students with a good academic foundation but also provides
                  opportunities to grow as people.
                </Typography>
                <br />
                <Typography
                  sx={{
                    color: 'var(--unnamed-color-151515)',
                    font: '30px ',
                    width: '100%',
                  }}
                >
                  <Typography sx={{ fontWeight: 700 }}>Published by</Typography>
                  Department: School of Public Health
                </Typography>
                <br />
              </CardContent>
            </Box>
          </Grid>
        </Box>
      </Grid>
      <Footer></Footer>
    </div>
  );
};

export default InnerBlog;
